import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { variantTokens } from '../../../theme/theme';

const { Text } = Typography;

// Costanti dei colori
const PRIMARY = variantTokens.primary;

/**
 * SmallModal - A reusable 400px modal component for simple interactions
 * 
 * @param {boolean} visible - Controls if the modal is visible
 * @param {function} onClose - Function called when modal is closed
 * @param {string} title - Modal title
 * @param {React.ReactNode} children - Custom content to display in the modal
 * @param {function} onConfirm - Function called when confirm button is clicked
 * @param {string} cancelText - Text for the cancel button
 * @param {string} confirmText - Text for the confirm button
 * @returns {React.ReactElement}
 */

const SmallModal = ({
    visible = false,
    onClose,
    title = "Small Modal",
    children,
    onConfirm,
    cancelText = "Close",
    confirmText = "Confirm"
}) => {
    const handleCancel = () => {
        if (onClose) onClose();
    };

    const handleConfirm = () => {
        if (onConfirm) onConfirm();
        handleCancel();
    };

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={handleCancel}
            footer={[
                <Button
                    key="back"
                    onClick={handleCancel}
                    style={{
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        height: 'auto',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    {cancelText}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={handleConfirm}
                    style={{
                        backgroundColor: PRIMARY,
                        borderColor: PRIMARY,
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        height: 'auto',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    {confirmText}
                </Button>,
            ]}
            width="clamp(17.5rem, 90vw, 25rem)"
            styles={{
                header: {
                    padding: 'clamp(0.75rem, 3vw, 1.25rem)',
                    fontSize: 'clamp(1rem, 3vw, 1.25rem)'
                },
                body: {
                    padding: 'clamp(0.75rem, 3vw, 1.25rem)'
                },
                footer: {
                    padding: 'clamp(0.5rem, 2vw, 1rem) clamp(0.75rem, 3vw, 1.25rem)'
                }
            }}
        >
            <div style={{ padding: 'clamp(0.75rem, 3vw, 1.25rem) 0' }}>
                {children || (
                    <>
                        <Text style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1rem)' }}>This is a small modal (400px).</Text>
                        <p style={{ marginTop: 'clamp(0.5rem, 2vw, 0.9375rem)', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}>
                            Use this type of modal for quick messages, confirmations
                            or simple operations that require minimal interaction.
                        </p>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default SmallModal; 